import Ghost from 'react-loading-skeleton';

import { Totals } from '..';

export const Skeleton: React.FC = () => (
	<Totals
		subTotal={<Ghost width={35} height={20} style={{ lineHeight: 1.5 }} />}
		taxAmount={<Ghost width={32} height={20} style={{ lineHeight: 1.5 }} />}
		total={<Ghost width={55} height={28} style={{ lineHeight: 2.3 }} />}
	/>
);
